"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAdmin = require("react-admin");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFinalForm = require("react-final-form");

var _reactRedux = require("react-redux");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _core = require("@material-ui/core");

var _PasswordField = _interopRequireDefault(require("../components/PasswordField"));

var _renderFormFieldInput = _interopRequireDefault(require("../components/renderFormFieldInput"));

var _formStyles = _interopRequireDefault(require("../styles/formStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LoginForm = function LoginForm(props) {
  var requestLogin = props.requestLogin;
  var translate = (0, _reactAdmin.useTranslate)();
  return _react.default.createElement(_reactFinalForm.Form, _extends({
    validate: function validate(values) {
      var errors = {};
      if (!values.username) errors.username = translate('ra.validation.required');
      if (!values.password) errors.password = translate('ra.validation.required');
      return errors;
    },
    onSubmit: function onSubmit(values) {
      requestLogin(values);
    }
  }, props), function (_ref) {
    var classes = _ref.classes,
        isLoading = _ref.isLoading,
        handleSubmit = _ref.handleSubmit,
        submitting = _ref.submitting;
    return _react.default.createElement("form", {
      onSubmit: function onSubmit(e) {
        return handleSubmit(e);
      }
    }, _react.default.createElement("div", {
      className: classes.form
    }, _react.default.createElement("div", {
      className: classes.input
    }, _react.default.createElement(_reactFinalForm.Field, {
      id: "username",
      name: "username",
      label: translate('ra.auth.username'),
      render: _renderFormFieldInput.default,
      disabled: isLoading || submitting
    })), _react.default.createElement("div", {
      className: classes.input
    }, _react.default.createElement(_PasswordField.default, {
      isFormLoading: isLoading || submitting,
      fieldComponent: _renderFormFieldInput.default
    }))), _react.default.createElement(_core.CardActions, null, _react.default.createElement(_core.Button, {
      type: "submit",
      disabled: isLoading,
      className: classes.button
    }, isLoading && _react.default.createElement(_core.CircularProgress, {
      size: 25,
      thickness: 2
    }), "LOGIN")));
  });
};

LoginForm.propTypes = {
  classes: _propTypes.default.object,
  requestLogin: _propTypes.default.func.isRequired
};
LoginForm.defaultProps = {
  classes: null
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: state.admin.loading > 0
  };
};

var enhance = (0, _compose.default)((0, _core.withStyles)(_formStyles.default), (0, _reactRedux.connect)(mapStateToProps));

var _default = enhance(LoginForm);

exports.default = _default;